import LeadfamlyGamePage from "./LeadFamlyGamePage";
export default LeadfamlyGamePage;
